<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline grey lighten-2 blue-grey--text text--darken-3">
          Link Award
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="linkedAward"
            :items="awards"
            :filter="customFilter"
            item-text="name"
            label="Award"
            prepend-icon="mdi-trophy"
            class="mt-8"
            return-object
            clearable
          ></v-autocomplete>

          <v-select
            v-model="year"
            :items="years"
            prepend-icon="mdi-calendar"
            label="Winning Year"
            clearable
          ></v-select>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog()"
          >
            Close
          </v-btn>
          <v-btn
            color="accent"
            text
            @click="save()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import messagesMixin from '@/mixins/messagesMixin'

export default {
  props: ['close', 'dialog', 'awards', 'years'],

  mixins: [messagesMixin],

  data () {
    return {
      linkedAward: {},
      year: null
    }
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    },

    customFilter (item, queryText) {
      return item.name.toLowerCase().indexOf(queryText.toLowerCase()) > -1
    },

    save () {
      if (!this.linkedAward || !this.year) {
        this.showCustomErrorMessage('Please fill all fields.', 2500)
        return
      }

      this.linkedAward.pivot = {
        year: this.year
      }

      this.$emit('link', this.linkedAward)

      this.linkedAward = {}
      this.year = null
    }
  }
}
</script>
